/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Component imports
import { Col, Row, Spin } from 'antd';
import AutomatedAnswerForm from './AutomatedAnswerForm';

// Misc imports
import { useBotLanguage } from '../../utils/hooks/useBotLanguage';
import { useFetchAutomatedAnswersQuery } from '../../store/automatedAnswers/automatedAnswersApi';
import { DEFAULT_FALLBACK_ID } from '../../constants/flowGraph';

const DefaultFallbacksForm = () => {
  const { tenantId, orgId } = useParams();
  const { currentBotLanguage } = useBotLanguage();

  const { data: automatedAnswers } = useFetchAutomatedAnswersQuery({ orgId, tenantId, currentBotLanguage });
  const [defaultFallback, setDefaultFallback] = useState(null);

  useEffect(() => {
    if (!automatedAnswers) {
      return;
    }

    setDefaultFallback(automatedAnswers.items.find(automatedAnswer => automatedAnswer.id === DEFAULT_FALLBACK_ID) ?? {});
  }, [automatedAnswers]);

  const renderDefaultFallbacks = () => {
    if (!defaultFallback) {
      return (
        <Row justify="center">
          <Col className="p-5">
            <Spin />
          </Col>
        </Row>
      );
    }

    return (
      <AutomatedAnswerForm
        selectedAA={defaultFallback}
        setSelectedAA={setDefaultFallback}
      />
    );
  };

  return (renderDefaultFallbacks());
};

export default DefaultFallbacksForm;
